import { createFileRoute } from '@tanstack/react-router'
import SettingsPasskeys from '@/features/settings/passkeys'

export const Route = createFileRoute('/_authenticated/settings/passkeys')({
  component: SettingsPasskeys,
})
